import { Component, inject } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { IconComponent } from '@shared/components/ui';

@Component({
  selector: 'app-not-found',
  imports: [IconComponent, TranslateModule],
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss'],
})
export class NotFoundComponent {
  private readonly _router = inject(Router);

  navigateToPreviousPage() {
    // Navigate to previous URL if possible
    if (history.state.navigationId > 1) {
      this._router.navigate(['/']); // navigates to default route
    } else {
      this._router.navigateByUrl('/dashboard'); // navigates to the dashboard
    }
  }
}
